"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _get = _interopRequireDefault(require("lodash/get"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _reactRouter = require("react-router");
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var _configuratorRedux = _interopRequireDefault(require("./configurator-redux"));
var _modelSelector = _interopRequireDefault(require("./model-selector"));
var _preferencesSelector = _interopRequireDefault(require("./preferences-selector"));
var _additionalEquipment = _interopRequireDefault(require("./additional-equipment/additional-equipment"));
var _colorSelector = _interopRequireDefault(require("./color-selector"));
var _fabricSelector = _interopRequireDefault(require("./fabric-selector"));
var _packagesSelector = _interopRequireDefault(require("./packages-selector"));
var _accessoriesSelector = _interopRequireDefault(require("./accessories-selector"));
var _summaryStep = _interopRequireDefault(require("./summary-step"));
var _insertAt = _interopRequireDefault(require("../utils/insertAt"));
var _configurator2 = require("./configurator.props/configurator.propTypes");
var _configurator3 = _interopRequireDefault(require("./configurator.props/configurator.queryStructures"));
var _configuratorError = _interopRequireDefault(require("./configurator-error"));
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
var _templateObject;
/* eslint-disable no-console */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  isEmptyObject = dataUtils.isEmptyObject;
var CTA_DATA_KEYS = ['cta', 'extraButtonCta', 'thirdButtonCta'];
var CF_CONFIGURATOR_QS_KEY = 'cf_configurator-url';
var configParamMap = {
  FUEL: 'fuelType',
  TRANSMISSION: 'transmissionType',
  DRIVE: 'drivetrain'
};
var isValidSelectionKey = function isValidSelectionKey(key) {
  return {
    vehicle: true,
    year: true,
    years: true,
    code: true,
    model: true,
    color: true,
    interiorColor: true,
    fabric: true,
    packages: true,
    accessories: true,
    driveType: true,
    fuelType: true,
    transmissionType: true,
    url: true,
    trim: true,
    latitude: true,
    longitude: true,
    totalPrice: true,
    trimLine: true
  }[key];
};

// Check if the object has a value at the specfied key
var hasParam = function hasParam(param, availableParams) {
  var paramFound = true;
  if (availableParams[param] === '' || availableParams[param] === undefined || availableParams[param] === null) {
    paramFound = false;
  }
  return paramFound;
};

// Check if the object has a value value in an array
// * Optionally add any unique passing parameters to an array
var checkParamSet = function checkParamSet(paramSet, availableParams, paramList) {
  var hasRequiredStepParams = true;
  for (var i = 0; i < paramSet.length; i += 1) {
    var param = paramSet[i];
    if (!hasParam(param, availableParams)) {
      hasRequiredStepParams = false;
    } else if (paramList !== undefined) {
      if (!paramList.includes(param)) {
        paramList.push(param);
      }
    }
  }
  return hasRequiredStepParams;
};

// Check if the users selections have satisfied their current step
var isStepSatisfied = function isStepSatisfied(step, availableParams) {
  var hasRequiredStepParams = true;
  for (var i = 0; i < step.paramSets.length; i += 1) {
    hasRequiredStepParams = true;
    var paramSet = step.paramSets[i];
    hasRequiredStepParams = checkParamSet(paramSet, availableParams);
    if (hasRequiredStepParams) {
      break;
    }
  }
  return hasRequiredStepParams;
};

// Return GraphQL Query object based on step label
var getStepQuery = function getStepQuery(stepQuery) {
  if (stepQuery === void 0) {
    stepQuery = 'getModelPreferencesSelector';
  }
  return (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  ", "\n"])), _configurator3["default"][stepQuery]);
};

// Return an array of the required fields based on the step label
var getRequiredParamsFromStepLabel = function getRequiredParamsFromStepLabel(currentStep, stepMap) {
  var stepParams = [];

  // Check each step to see if we have all of the required information for that step
  for (var i = 0; i < stepMap.length; i += 1) {
    var paramSets = stepMap[i].paramSets;
    // Check each parameter in the set to make sure that we satisfy all of them
    paramSets[0].forEach(function (param) {
      if (!stepParams.includes(param)) {
        stepParams.push(param);
      }
    });
    // If this step has not been satified break the loop
    if (currentStep === stepMap[i].label) {
      break;
    }
  }

  // Return the furthest satisfied step
  return stepParams;
};

// Return an object with only the data from the fields in the specified array
var getConfigurationFromPreferencesAndRequirements = function getConfigurationFromPreferencesAndRequirements(preferences, requirements) {
  var configuration = {};
  requirements.forEach(function (param) {
    if (preferences[param]) {
      configuration[param] = preferences[param];
    }
  });

  // Set cookie to remember user selection for 20min
  if (configuration.vehicle && typeof document !== 'undefined') {
    document.cookie = "carSelected=" + configuration.vehicle + "_" + configuration.year + "; SameSite=Strict; Max-Age=1200; Path=/"; // eslint-disable-line
  }
  return configuration;
};

// Return an object with only the required data based on the step you are on
var getRequiredConfigurationFromPreferencesAtStep = function getRequiredConfigurationFromPreferencesAtStep(currentStep, preferences, stepMap) {
  if (currentStep === void 0) {
    currentStep = 'ModelPreferencesSelector';
  }
  var requirements = getRequiredParamsFromStepLabel(currentStep, stepMap);
  var configuration = getConfigurationFromPreferencesAndRequirements(preferences, requirements);
  return configuration;
};
var getStepRequirementsFromAvailableParams = function getStepRequirementsFromAvailableParams(availableParams, currentStep, stepMap) {
  if (currentStep === void 0) {
    currentStep = 'ModelPreferencesSelector';
  }
  var stepLabel = currentStep;
  var stepParams = [];

  // Check each step to see if we have all of the required information for that step
  for (var i = 0; i < stepMap.length; i += 1) {
    var hasRequiredStepParams = true;
    var paramSets = stepMap[i].paramSets;
    // Check each of the available parameter sets that could satisfy this step
    for (var k = 0; k < paramSets.length; k += 1) {
      var paramSet = paramSets[k];
      hasRequiredStepParams = true;
      // Check each parameter in the set to make sure that we satisfy all of them
      hasRequiredStepParams = checkParamSet(paramSet, availableParams, stepParams);
      // Break this loop to indicate that one of the sets has been satified, we can check the next step
      if (hasRequiredStepParams) {
        break;
      }
    }
    // If this step has not been satified break the loop
    if (hasRequiredStepParams || stepLabel === 'ModelPreferencesSelector' && (hasParam('transmissionType', availableParams) || hasParam('fuelType', availableParams) || hasParam('driveType', availableParams))) {
      stepLabel = stepMap[i].label;
    } else {
      break;
    }
  }
  // Return the furthest satisfied step
  return {
    params: stepParams,
    label: stepLabel
  };
};
var ConfiguratorApollo = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorApollo, _React$Component);
  ConfiguratorApollo.makeConfigFieldsFromFilter = function makeConfigFieldsFromFilter(filter) {
    return filter !== ' ' && filter ? filter.reduce(function (acc, curr) {
      acc[configParamMap[curr.label]] = curr.filteringOptions.length > 0 ? curr.filteringOptions[0].label : '';
      return acc;
    }, {}) : {};
  };
  ConfiguratorApollo.getSafeInputSelection = function getSafeInputSelection(selection) {
    return Object.keys(selection).reduce(function (safeSection, key) {
      var _ref;
      return _objectSpread(_objectSpread({}, safeSection), isValidSelectionKey(key) ? (_ref = {}, _ref[key] = selection[key], _ref) : {});
    }, {});
  };
  ConfiguratorApollo.getQueryObject = function getQueryObject(selections, activeStep) {
    // Set URL Query Params based on object

    var urlSafeSelections = JSON.parse(JSON.stringify(selections));
    var packagesToAdd = selections.packages;
    var accessoriesToAdd = selections.accessories;
    if (packagesToAdd !== undefined) {
      urlSafeSelections.packages = packagesToAdd.join(',');
    }
    if (accessoriesToAdd !== undefined) {
      urlSafeSelections.accessories = accessoriesToAdd.join(',');
    }
    Object.keys(urlSafeSelections).forEach(function (key) {
      if (urlSafeSelections[key] === '' || urlSafeSelections[key] === undefined || urlSafeSelections[key] === null) {
        delete urlSafeSelections[key];
      }
    });
    urlSafeSelections.step = activeStep;
    return urlSafeSelections;
  };
  function ConfiguratorApollo(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var data = props.data,
      market = props.market;
    var isUSMarket = market === 'us';
    var hasAdditionalEquipmentStep = isUSMarket;
    var stepMap = [{
      id: 'ModelPreferences_1_0_0',
      component: _preferencesSelector["default"],
      label: 'ModelPreferencesSelector',
      stepName: 'preference',
      query: 'getModelPreferencesSelector',
      paramSets: [['vehicle', 'year']]
    }, {
      id: 'ModelSelector_1_0_0',
      component: _modelSelector["default"],
      label: 'ModelSelector',
      stepName: 'model',
      query: 'getModelsSelector',
      paramSets: [['driveType', 'fuelType', 'transmissionType', 'trimLine'], [hasAdditionalEquipmentStep ? 'trimLine' : 'model']]
    }, {
      id: 'ColourSelector_1_0_0',
      component: _colorSelector["default"],
      label: 'ColorSelector',
      stepName: 'exterior',
      query: 'getColorSelector',
      paramSets: [['model']]
    }, {
      id: 'FabricSelector_1_0_0',
      component: _fabricSelector["default"],
      label: 'FabricSelector',
      stepName: 'interior',
      query: 'getFabricSelector',
      paramSets: [['color']]
    }, {
      id: 'PackageSelector_1_0_0',
      component: _packagesSelector["default"],
      label: 'PackagesSelector',
      stepName: 'package',
      query: 'getPackagesSelector',
      paramSets: [['fabric']]
    }, {
      id: 'AccessorySelector_1_0_0',
      component: _accessoriesSelector["default"],
      label: 'AccessoriesSelector',
      stepName: 'accessory',
      query: 'getAccessoriesSelector',
      paramSets: [['packages'], ['fabric']]
    }, {
      id: 'SummarySelector_1_0_0',
      component: _summaryStep["default"],
      label: 'SummarySelector',
      stepName: 'summary',
      query: 'getSummarySelector',
      paramSets: [['accessories'], ['fabric']]
    }];
    if (hasAdditionalEquipmentStep) {
      (0, _insertAt["default"])(stepMap, 2, {
        id: 'AdditionalEquipment_1_0_0',
        component: _additionalEquipment["default"],
        label: 'AdditionalEquipmentSelector',
        stepName: 'additionalEquipment',
        query: 'getAdditionalEquipmentSelector',
        paramSets: [['driveType', 'fuelType', 'transmissionType', 'trimLine'], ['model']]
      });
    }
    _this.stepMap = stepMap;
    _this.hasAdditionalEquipmentStep = hasAdditionalEquipmentStep;
    var initialConfiguration = {};
    var activeStep = {
      params: [],
      label: 'ModelPreferencesSelector'
    };
    var location = props.location || {
      query: {}
    };
    var initialPreferences = location.query;
    if (initialPreferences.year !== undefined) {
      initialPreferences.year = Number(initialPreferences.year);
    }
    if (initialPreferences.packages !== undefined) {
      initialPreferences.packages = initialPreferences.packages.split(',');
    }
    if (initialPreferences.accessories !== undefined) {
      initialPreferences.accessories = initialPreferences.accessories.split(',');
    }
    if (!isEmptyObject(initialPreferences)) {
      if (initialPreferences.step) {
        activeStep = stepMap.find(function (step) {
          return step.label === initialPreferences.step;
        });
        if (!activeStep) {
          // No active step, redirect to landing
          _this.handleInvalidConfiguration(data.steps[0].progressBar);
          activeStep = {};
        }
        delete initialPreferences.step;
        initialPreferences.year = Number(initialPreferences.year);
        initialConfiguration = initialPreferences;
      } else {
        activeStep = getStepRequirementsFromAvailableParams(initialPreferences, activeStep.label, stepMap);
        initialConfiguration = getConfigurationFromPreferencesAndRequirements(initialPreferences, activeStep.params);
      }
    }
    _this.lastPageRef = /*#__PURE__*/(0, _react.createRef)();
    _this.setSelections = _this.setSelections.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateSelections = _this.updateSelections.bind((0, _assertThisInitialized2["default"])(_this));
    _this.goToStepFromIndex = _this.goToStepFromIndex.bind((0, _assertThisInitialized2["default"])(_this));
    _this.parseStepData = _this.parseStepData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.resetGraphQLError = _this.resetGraphQLError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.restartTool = _this.restartTool.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      preferences: initialPreferences,
      configuration: initialConfiguration,
      activeStep: activeStep.label,
      queryPending: false,
      minorQueryPending: 0,
      stepData: _this.parseStepData(data.steps[0]),
      skipPrefs: false,
      skipOptions: {},
      priceOptions: {},
      hasGraphQLError: false
    };
    return _this;
  }
  var _proto = ConfiguratorApollo.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    var stepMap = this.stepMap;
    var _this$state = this.state,
      configuration = _this$state.configuration,
      activeStep = _this$state.activeStep,
      stepData = _this$state.stepData;
    var router = this.props.router;
    var currentStepIndex = stepMap.findIndex(function (step) {
      return step.label === activeStep;
    });
    if (currentStepIndex !== -1 && !isEmptyObject(configuration)) {
      this.updateQuery(stepMap[currentStepIndex], configuration);
    } else {
      // No configuration, redirect to landing
      this.handleInvalidConfiguration(stepData.progressBar);
    }
    var currentStep = stepMap[currentStepIndex];

    // Listen to the router
    this.unlisten = router.listen(function (location) {
      _commonLibs.EventEmitter.dispatch('configuratorStepChanged', '');
      _this2.updateViewFromRouteChange(location, currentStep);
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    // Unlisten to the router
    this.unlisten();
  };
  _proto.handleInvalidConfiguration = function handleInvalidConfiguration(progressBar) {
    var router = this.props.router;
    console.warn('Invalid or unset configuration passed into configurator.'); // eslint-disable-line
    var url = dataUtils.handleNestedProp(progressBar, 'progressBar.previousCta.URL');
    if (url) {
      window.location = url;
    }
  };
  _proto.getCmsPath = function getCmsPath() {
    var _this$props = this.props,
      market = _this$props.market,
      path = _this$props.path,
      language = _this$props.language,
      location = _this$props.location;
    // If a path prop is passed in, prefer that.
    if (path) {
      return path;
    }
    // Else, generate the cms path from props
    var combinedPath = location.pathname;
    if (combinedPath.indexOf("/" + language + "/") === 0) {
      return "/" + market + combinedPath;
    }
    return "/" + market + "/" + language + combinedPath;
  };
  _proto.getNextStep = function getNextStep() {
    var stepMap = this.stepMap;
    var _this$state2 = this.state,
      stepData = _this$state2.stepData,
      activeStep = _this$state2.activeStep;
    var progressBarItems = handleNestedProp(stepData, 'stepData.progressBar.items');
    var currentStepInformation = stepMap.find(function (step) {
      return step.label === activeStep;
    });
    if (progressBarItems !== ' ' && progressBarItems !== null && progressBarItems !== undefined) {
      var currentStepNavIndex = progressBarItems.findIndex(function (step) {
        return step.stepName === currentStepInformation.stepName;
      });
      var nextStepInformation = stepMap.find(function (step) {
        return step.stepName === progressBarItems[currentStepNavIndex + 1].stepName;
      });
      return nextStepInformation;
    }
    return currentStepInformation;
  };
  _proto.setSelections = function setSelections(selections) {
    var stepMap = this.stepMap;
    var _this$state3 = this.state,
      activeStep = _this$state3.activeStep,
      preferences = _this$state3.preferences;
    var updatedStep = activeStep;
    var currentStepIndex = stepMap.findIndex(function (step) {
      return step.label === activeStep;
    });
    var updatedConfiguration = {};
    if (isStepSatisfied(stepMap[currentStepIndex], selections)) {
      var nextStep = this.getNextStep();
      updatedStep = nextStep.label;
      updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(nextStep.label, selections, stepMap);
      if (nextStep) {
        this.updateQuery(nextStep, updatedConfiguration);
      }
    } else {
      updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(updatedStep, selections, stepMap);
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          configuration: updatedConfiguration,
          preferences: _objectSpread(_objectSpread({}, preferences), updatedConfiguration)
        });
      });
    }
    this.updateQueryParams(ConfiguratorApollo.getQueryObject(updatedConfiguration, updatedStep));
  };
  _proto.updateCanonicalLink = function updateCanonicalLink(_ref2) {
    var canonicalLink = _ref2.canonicalLink;
    var currentLink = document.querySelector("link[rel='canonical']");
    if (currentLink) {
      currentLink.remove();
    }
    var link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalLink);
    document.head.appendChild(link);
  };
  _proto.updateTitle = function updateTitle(_ref3) {
    var year = _ref3.year,
      name = _ref3.name;
    var market = this.props.market;
    var siteName = document.title.split('|')[1];
    if (siteName && year && name && market === 'us' && typeof window !== 'undefined') {
      var newTitle = year + " Mitsubishi " + name + " Build & Price | " + siteName;
      var canonicalLink = window.location.href;
      document.title = newTitle;
      this.updateCanonicalLink({
        canonicalLink: canonicalLink
      });
    }
  };
  _proto.parseStepData = function parseStepData(data) {
    if (data === void 0) {
      data = {};
    }
    var market = this.props.market;
    if (market !== 'ca') {
      return data;
    }
    var out = _objectSpread({}, data);
    var isBookATestDriveCTA = function isBookATestDriveCTA(label) {
      return Boolean(typeof label === 'string' && label.match(/test drive/i));
    };
    var addConfiguratorURLQueryString = function addConfiguratorURLQueryString(url) {
      if (typeof url !== 'string') return url;
      if (typeof window !== 'undefined') {
        var href = encodeURIComponent(window.location.href);
        return url + "&" + CF_CONFIGURATOR_QS_KEY + "=" + href;
      }
    };

    // Find the Test Drive CTA if any & add configurator URL query param
    for (var i = 0, len = CTA_DATA_KEYS.length; i < len; i += 1) {
      var cta = (0, _get["default"])(out, CTA_DATA_KEYS[i]);
      if (cta && isBookATestDriveCTA(cta.label)) {
        cta.url = addConfiguratorURLQueryString(cta.url);
        break;
      }
    }
    return out;
  };
  _proto.updateSelections = function updateSelections(selections) {
    var stepMap = this.stepMap,
      hasAdditionalEquipmentStep = this.hasAdditionalEquipmentStep;
    var carouselUpdateMap = {
      ModelSelector: 'model',
      AdditionalEquipmentSelector: 'model',
      ColorSelector: 'color',
      FabricSelector: 'fabric'
    };
    var _this$state4 = this.state,
      activeStep = _this$state4.activeStep,
      preferences = _this$state4.preferences;
    var currentStepIndex = stepMap.findIndex(function (step) {
      return step.label === activeStep;
    });
    if (currentStepIndex === stepMap.length - 1) {
      currentStepIndex = 0;
    }
    var updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(stepMap[currentStepIndex + 1].label, _objectSpread(_objectSpread({}, preferences), selections), stepMap);

    // Do additional carousel loading checks if images are affected
    if (carouselUpdateMap[activeStep] !== undefined) {
      if (hasAdditionalEquipmentStep) {
        preferences.model = preferences.trimLine;
      }
      if (preferences[carouselUpdateMap[activeStep]] === undefined) {
        // Requested with default data no additional request required
        this.setState(function (prevState) {
          return Object.assign(prevState, {
            preferences: Object.assign(preferences, updatedConfiguration)
          });
        });
      } else {
        var isMinor = preferences[carouselUpdateMap[activeStep]] !== selections[carouselUpdateMap[activeStep]];
        this.updateQuery(stepMap[currentStepIndex], updatedConfiguration, isMinor);
      }
    } else {
      this.updateQuery(stepMap[currentStepIndex], updatedConfiguration, false);
    }
  };
  _proto.restartTool = function restartTool() {
    this.resetGraphQLError();
    var stepMap = this.stepMap;
    var desiredStep = stepMap[0];
    var activeStep = this.state.activeStep;
    if (activeStep === desiredStep.label && typeof window !== 'undefined') {
      window.location.reload();
    } else {
      this.goToStepFromIndex(0);
    }
  };
  _proto.goToStepFromIndex = function goToStepFromIndex(stepIndex, clearPreferences) {
    var _this3 = this;
    var stepMap = this.stepMap;
    var data = this.props.data;
    var _this$state5 = this.state,
      activeStep = _this$state5.activeStep,
      preferences = _this$state5.preferences;
    var desiredStep = stepMap[stepIndex];
    var updatedConfiguration = {};
    if (desiredStep !== null && activeStep !== desiredStep.label) {
      if (desiredStep.query !== null) {
        var preferencesToUse = preferences;
        if (clearPreferences === true) {
          // Clear preference data when coming from a modal
          preferencesToUse = {
            vehicle: preferences.vehicle,
            year: preferences.year,
            model: preferences.model
          };
          this.setState({
            preferences: preferencesToUse
          }, function () {
            updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(desiredStep.label, preferencesToUse, stepMap);
            _this3.updateQuery(desiredStep, updatedConfiguration);
          });
        } else {
          updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(desiredStep.label, preferencesToUse, stepMap);
          this.updateQuery(desiredStep, updatedConfiguration);
        }
      } else {
        updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(desiredStep.label, preferences, stepMap);
        this.setState({
          configuration: updatedConfiguration,
          activeStep: desiredStep.label,
          stepData: this.parseStepData(data.steps[stepIndex])
        });
      }
      this.updateQueryParams(ConfiguratorApollo.getQueryObject(updatedConfiguration, desiredStep.label));
    }
  };
  _proto.goToStepFromParams = function goToStepFromParams(params) {
    var _this4 = this;
    var stepMap = this.stepMap;
    var desiredStepRequirements = getStepRequirementsFromAvailableParams(params, null, stepMap);
    var desiredStepIndex = stepMap.findIndex(function (step) {
      return step.label === desiredStepRequirements.label;
    });
    var desiredStep = stepMap[desiredStepIndex];
    var updatedConfiguration = {};
    if (desiredStep !== null) {
      if (desiredStep.query !== null) {
        updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(desiredStep.label, params, stepMap);
        this.updateQuery(desiredStep, updatedConfiguration);
      } else {
        var data = this.props.data;
        updatedConfiguration = getRequiredConfigurationFromPreferencesAtStep(desiredStep.label, params, stepMap);
        this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            configuration: updatedConfiguration,
            activeStep: desiredStep.label,
            stepData: _this4.parseStepData(data.steps[desiredStepIndex])
          });
        });
      }
      this.updateQueryParams(ConfiguratorApollo.getQueryObject(updatedConfiguration, desiredStep.label));
    }
  }

  // Handling for back and forward buttons (changing the query params)
  ;
  _proto.updateViewFromRouteChange = function updateViewFromRouteChange(location, currentStep) {
    var _this5 = this;
    var stepMap = this.stepMap;
    if (location.action === 'POP') {
      setTimeout(function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 200);
      if (location.query.step) {
        var desiredStep = stepMap.find(function (step) {
          return step.label === location.query.step;
        });
        var updatedConfig = JSON.parse(JSON.stringify(location.query));
        if (updatedConfig.packages) {
          if (typeof updatedConfig.packages === 'string') {
            updatedConfig.packages = updatedConfig.packages.split(',');
          } else {
            updatedConfig.packages = [];
          }
        }
        if (updatedConfig.accessories) {
          if (typeof updatedConfig.accessories === 'string') {
            updatedConfig.accessories = updatedConfig.accessories.split(',');
          } else {
            updatedConfig.accessories = [];
          }
        }
        updatedConfig.year = Number(updatedConfig.year);
        delete updatedConfig.step;
        this.setState({
          activeStep: desiredStep.label
        }, function () {
          _this5.updateQuery(desiredStep, updatedConfig);
        });
      } else {
        var lastPage = this.lastPageRef.current;
        var isModelSelectionStep = lastPage === 'preference';
        this.lastPageRef.current = currentStep.stepName;

        // if on `Model Selection` step, let back button redirect to car selection, else go to location.query
        if (!isModelSelectionStep) {
          this.goToStepFromParams(location.query);
        }
      }
    }
  }

  // Set URL Query Params based on object
  ;
  _proto.updateQueryParams = function updateQueryParams(selection) {
    var _this$props2 = this.props,
      location = _this$props2.location,
      router = _this$props2.router;
    var query = _objectSpread({}, selection);

    // Keep market & language for `preview` environment
    if (location.query.market) {
      query.market = location.query.market;
    }
    if (location.query.language) {
      query.language = location.query.language;
    }
    router.push({
      pathname: location.pathname,
      query: query
    });
  };
  _proto.isColorCodeValid = function isColorCodeValid(colorCode) {
    var stepData = this.state.stepData;
    return stepData.carousel && stepData.carousel.items && stepData.carousel.items[0] && stepData.carousel.items[0].image && stepData.carousel.items[0].image.image && stepData.carousel.items[0].image.image.toUpperCase().includes(colorCode.toUpperCase());
  }

  // Make a new GraphQL Query
  ;
  _proto.updateQuery = function updateQuery(nextStep, updatedConfiguration, isMinor) {
    var _this6 = this;
    var _this$props3 = this.props,
      market = _this$props3.market,
      language = _this$props3.language,
      client = _this$props3.client,
      location = _this$props3.location;
    var _this$state6 = this.state,
      preferences = _this$state6.preferences,
      activeStep = _this$state6.activeStep,
      minorQueryPending = _this$state6.minorQueryPending,
      queryPending = _this$state6.queryPending;
    var configurationToSend = JSON.parse(JSON.stringify(updatedConfiguration));
    var preferencesToUse = JSON.parse(JSON.stringify(preferences));
    if (preferencesToUse.color && configurationToSend.color === undefined) {
      configurationToSend.color = preferencesToUse.color;
    }

    // Scrolling to top on step change
    if (nextStep.label !== activeStep && typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (typeof window !== 'undefined' && window.scrollTo !== undefined) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        document.body.scrollTop = 0; // eslint-disable-line
      }
    }
    if (nextStep.label === 'ModelPreferencesSelector') {
      delete preferencesToUse.transmissionType;
      delete preferencesToUse.driveType;
      delete preferencesToUse.fuelType;

      // Return all models and sort on the front end
      delete configurationToSend.transmissionType;
      delete configurationToSend.driveType;
      delete configurationToSend.fuelType;
    } else if ((nextStep.label === 'ModelSelector' || nextStep.label === 'AdditionalEquipmentSelector') && configurationToSend.model === undefined) {
      configurationToSend.model = preferencesToUse.model;
    }
    var routerLocation = location || {
      pathname: '',
      search: ''
    };
    var safeQueryParams = ConfiguratorApollo.getQueryObject(configurationToSend, nextStep.label);
    var urlQueryString = '?';
    Object.keys(safeQueryParams).forEach(function (key) {
      urlQueryString += key + "=" + safeQueryParams[key] + "&";
    });
    urlQueryString = urlQueryString.slice(0, -1);
    configurationToSend.url = "" + routerLocation.pathname + urlQueryString;
    this.setState(function () {
      return {
        queryPending: isMinor === undefined,
        minorQueryPending: isMinor === true ? minorQueryPending + 1 : minorQueryPending
      };
    });
    var queryConfig = {
      market: market,
      language: language,
      path: this.getCmsPath(),
      selection: ConfiguratorApollo.getSafeInputSelection(configurationToSend)
    };
    if (queryConfig.selection.year) {
      queryConfig.selection.year = parseInt(queryConfig.selection.year, 10);
    }
    client.query({
      query: getStepQuery(nextStep.query),
      variables: queryConfig
    }).then(function (response) {
      var stepMap = _this6.stepMap;
      var stepData = _this6.parseStepData(response.data[nextStep.query]);
      if (stepData.vehicleInfo) {
        _this6.updateTitle({
          year: stepData.vehicleInfo.year,
          name: stepData.vehicleInfo.name
        });
      }

      // Special considerations for ModelPreferencesSelector
      if (nextStep.label === 'ModelPreferencesSelector') {
        _this6.updateDatalayer(stepData);
        var filters = handleNestedProp(stepData, 'stepData.filterSection.filters');
        var showPreferencesStep = false;

        // Check if a filter has more than one option
        if (filters !== ' ' && filters) {
          for (var i = 0; i < filters.length; i += 1) {
            if (filters[i].filteringOptions.length > 1) {
              showPreferencesStep = true;
            }
          }
        }
        if (showPreferencesStep) {
          // Add model data to our preference data to disable/enable options
          _this6.addModelsQuery(queryConfig, stepData, updatedConfiguration, nextStep, preferencesToUse);
        } else {
          // Skip straight to the Model Selection step
          var stepToSkipTo = stepMap.find(function (step) {
            return step.label === 'ModelSelector';
          });
          _this6.setState(
          // Setting a flag to say we skipped the first step and passing in the skipped options as an object
          function () {
            return {
              skipPrefs: true,
              skipOptions: ConfiguratorApollo.makeConfigFieldsFromFilter(filters)
            };
          }, _this6.updateQuery(stepToSkipTo, updatedConfiguration) // Firing the updateQuery to go to model select
          );
        }
      } else if (stepData !== undefined) {
        _this6.setState(function () {
          return {
            configuration: updatedConfiguration,
            activeStep: nextStep.label,
            stepData: stepData,
            queryPending: !isMinor ? false : queryPending,
            minorQueryPending: isMinor === true ? minorQueryPending - 1 : minorQueryPending,
            preferences: _objectSpread(_objectSpread({}, preferences), updatedConfiguration)
          };
        });
      }
    })["catch"](function (err) {
      var _err$networkError;
      console.log(' ');
      console.log('Configurator graphql error!');
      console.log(' ');
      console.log('graphql error information:', err);
      console.log(' ');
      console.log('graphql input information:');
      console.log(' ');
      console.log({
        query: getStepQuery(nextStep.query),
        variables: queryConfig
      });
      console.log(' ');
      // If query failed due to unavailable color code tried again with no color code specified
      if (err.message.includes('exterior color') && nextStep.label === 'ColorSelector' && preferencesToUse.color !== undefined) {
        delete preferencesToUse.color;
        _this6.setState(function () {
          return {
            preferences: _objectSpread({}, preferencesToUse)
          };
        }, function () {
          _this6.updateQuery(nextStep, updatedConfiguration, isMinor);
        });
      } else if ((_err$networkError = err.networkError) != null && _err$networkError.statusCode) {
        _this6.setState({
          hasGraphQLError: true
        });
      }
    });
  };
  _proto.updateDatalayer = function updateDatalayer(stepData) {
    var vehicleInfo = stepData.vehicleInfo;
    var market = this.props.market;
    var _getCachedLocation = (0, _commonSetLocation.getCachedLocation)(),
      stateCode = _getCachedLocation.stateCode,
      postalCode = _getCachedLocation.postalCode,
      city = _getCachedLocation.city;
    if (market.toLowerCase() === 'ca' && typeof window !== 'undefined' && window.dataLayer && ['/en/buy/configure-your-mitsubishi/configurator', '/fr/acheter/configuration-et-prix/configurator'].includes(window.location.pathname) && window.dataLayer.filter(function (item) {
      return item.event === 'bnp_start';
    }).length <= 0) {
      var nameplate = (0, _commonLibs.getNameplateByVehicleName)(vehicleInfo == null ? void 0 : vehicleInfo.name);
      var dataCollection = {
        event: "bnp_start",
        nameplate: nameplate,
        vehicle_category_code: _commonLibs.VEHICLE_CATEGORY_CODES[nameplate],
        province: stateCode == null ? void 0 : stateCode.toLowerCase(),
        postal_code: postalCode == null ? void 0 : postalCode.toUpperCase(),
        city: city == null ? void 0 : city.toLowerCase()
      };
      dataCollection = (0, _commonLibs.cleanObject)(dataCollection);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataCollection);
    }
  };
  _proto.addModelsQuery = function addModelsQuery(queryConfig, stepData, updatedConfiguration, nextStep, preferencesToUse) {
    var _this7 = this;
    var client = this.props.client;
    client.query({
      query: getStepQuery('getModelsSelector'),
      variables: queryConfig
    }).then(function (additionalResponse) {
      var additionalStepData = additionalResponse.data.getModelsSelector;
      if (additionalStepData !== undefined) {
        var models = additionalStepData.models || [];
        if (!models.length) {
          // Invalid model or year passed in
          _this7.handleInvalidConfiguration(additionalStepData.progressBar);
        }
        _this7.setState(function () {
          return {
            configuration: updatedConfiguration,
            activeStep: nextStep.label,
            stepData: _this7.parseStepData(_objectSpread(_objectSpread({}, stepData), {}, {
              models: models
            })),
            queryPending: false,
            preferences: _objectSpread(_objectSpread({}, preferencesToUse), updatedConfiguration)
          };
        });
      }
    })["catch"](function (err) {
      var _err$networkError2;
      if ((_err$networkError2 = err.networkError) != null && _err$networkError2.statusCode) {
        _this7.setState({
          hasGraphQLError: true
        });
      }
    });
  };
  _proto.resetGraphQLError = function resetGraphQLError() {
    this.setState({
      hasGraphQLError: false
    });
  };
  _proto.render = function render() {
    var stepMap = this.stepMap,
      hasAdditionalEquipmentStep = this.hasAdditionalEquipmentStep;
    var _this$props4 = this.props,
      data = _this$props4.data,
      theme = _this$props4.theme,
      market = _this$props4.market,
      router = _this$props4.router;
    var _this$state7 = this.state,
      preferences = _this$state7.preferences,
      activeStep = _this$state7.activeStep,
      stepData = _this$state7.stepData,
      queryPending = _this$state7.queryPending,
      minorQueryPending = _this$state7.minorQueryPending,
      skipPrefs = _this$state7.skipPrefs,
      skipOptions = _this$state7.skipOptions,
      hasGraphQLError = _this$state7.hasGraphQLError;
    var changeVehicleOverlay = data.changeVehicleOverlay,
      addPriceDisclaimer = data.addPriceDisclaimer,
      priceDisclaimerId = data.priceDisclaimerId,
      disclaimerData = data.disclaimerData,
      hasModelsOrdering = data.hasModelsOrdering;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].configuratorWrapper
    }, hasGraphQLError ? /*#__PURE__*/_react["default"].createElement(_configuratorError["default"], {
      theme: theme,
      configuratorErrorTitle: data.configuratorErrorTitle,
      configuratorErrorDescription: data.configuratorErrorDescription,
      refreshPageCtaLabel: data.refreshPageCtaLabel,
      restartToolCtaLabel: data.restartToolCtaLabel,
      cancelRestartCtaLabel: data.cancelRestartCtaLabel,
      confirmRestartCtaLabel: data.confirmRestartCtaLabel,
      restartToolTitle: data.restartToolTitle,
      restartToolDescription: data.restartToolDescription,
      restartTool: this.restartTool
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].loader + " " + (queryPending ? _configurator["default"].isLoading : '')
    }), /*#__PURE__*/_react["default"].createElement(_configuratorRedux["default"], {
      stepMap: stepMap,
      hasAdditionalEquipmentStep: hasAdditionalEquipmentStep,
      theme: theme,
      data: stepData,
      market: market,
      minorQueryPending: minorQueryPending,
      changeVehicleOverlay: changeVehicleOverlay,
      preferences: preferences,
      setSelections: this.setSelections,
      updateSelections: this.updateSelections,
      goToStepFromIndex: this.goToStepFromIndex,
      activeStep: activeStep,
      hasSelector: data.steps[0].selectorGrid !== undefined,
      router: router,
      didSkipPrefs: skipPrefs,
      skipOptions: skipOptions,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      hasModelsOrdering: hasModelsOrdering
    })));
  };
  return ConfiguratorApollo;
}(_react["default"].Component);
ConfiguratorApollo.displayName = 'ConfiguratorApollo';
ConfiguratorApollo.defaultProps = {
  market: 'language-masters',
  language: 'en',
  path: '',
  client: {}
};
var _default = (0, _reactRouter.withRouter)(ConfiguratorApollo);
exports["default"] = _default;